"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = require("../shared/styles");
var _jsxRuntime = require("react/jsx-runtime");
var Group = _styledComponents.default.div.withConfig({
  displayName: "ContextMenuGroup__Group",
  componentId: "sc-18uv5cp-0"
})(["display:block;flex-flow:column nowrap;width:100%;:not(:last-of-type){margin-bottom:", ";padding-bottom:", ";border-bottom:1px solid ", ";}"], _styles.spacing.xs, _styles.spacing.xs, _styles.colors.border.primary.default);
var ContextMenuGroup = function ContextMenuGroup(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Group, {
    children: children
  });
};
ContextMenuGroup.defaultProps = {};
var _default = exports.default = ContextMenuGroup;